module.exports = __webpack_public_path__ + "img/bell_1.b9ec8053.jpg";